export function cleanIHI(identifier) {
    switch (identifier.type) {
        case 'ihi':
            return { ...identifier, ihi: identifier.ihi.replace(/ /g, '') };
        case 'med':
            return { ...identifier, number: identifier.number.replace(/ /g, '') };
        case 'dva':
            return { ...identifier, number: identifier.number.replace(/ /g, '') };
    }
}
export function extractClientIP(req) {
    const header = req.headers.get('X-Forwarded-For');
    if (header)
        return header;
}
